import React,{Fragment} from 'react';
import './index.scss';
import DataGrid, {Column} from 'devextreme-react/data-grid';
import {createStore} from "devextreme-aspnet-data-nojquery";
import url from '../../../../api/base-url';
import sessions from '../../../../sessions';
const UserManagement = () =>{
    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               "x-access-token": auth
            }  
        }  
        return options;  
    };
    const usersDataSource = createStore(getConfig({
            key: 'userId', 
            loadUrl: `${url}/profile/${userId}`
    }));
    const dateOptions = {
        useMaskBehavior: true,
        type: "date",
        displayFormat: "shortdate"
    }
    const nameOptions = {
        width: '100px'
    }
    return(
        <Fragment>
        <h4 className={'content-block'}>User Management</h4>
        <div className={'content-block'}>
            <DataGrid dataSource={usersDataSource}
             showBorders={false}
             focusedRowEnabled={true}
             allowColumnReordering={true}
             allowColumnResizing={true}
             columnAutoWidth={true}
             columnHidingEnabled={true}
             wordWrapEnabled={true}
            >
                <Column editorType={'dxTextBox'} dataField={'username'} />
                <Column editorType={'dxTextBox'} dataField={'roles'}/>
                <Column editorType={'dxTextBox'} dataField={'companyName'}/>
                <Column editorType={'dxDateBox'} dataField={'createdAt'} editorOptions={dateOptions} dataType="date"/>
                <Column editorType={'dxDateBox'} dataField={'updatedAt'} editorOptions={dateOptions} dataType="date"/>
            </DataGrid>
        </div>
        
        </Fragment>
    );
}
export default UserManagement;